import { lazy } from 'react'
import { LoopModule } from 'src/services/openApiV2'

const ReviewsAndRatingsTrends = lazy(() => import('src/pages/members/RatingAndReviewsPages/Trends/Trends'))
const ReviewsAndRatingsStoreRatings = lazy(() => import('src/pages/members/RatingAndReviewsPages/StoreRatings/StoreRatings'))
const ReviewsAndRatingsReviews = lazy(() => import('src/pages/members/RatingAndReviewsPages/Reviews/Reviews'))
const ResponseConfiguration = lazy(() => import('src/pages/members/ResponseConfiguration/ResponseConfiguration'))
const Benchmarks = lazy(() => import('src/pages/members/Benchmarks/Benchmarks'))

export const reEngageRoutes = [
  {
    path: 're-engage',
    children: [
      { index: true, element: <ReviewsAndRatingsTrends /> },
      { path: 'trends', element: <ReviewsAndRatingsTrends /> },
      { path: 'store-ratings', element: <ReviewsAndRatingsStoreRatings /> },
      { path: 'reviews', element: <ReviewsAndRatingsReviews /> },
      { path: 'response-automation', element: <ResponseConfiguration /> },
      { path: 'benchmarks', element: <Benchmarks module={LoopModule.REENG} /> }
    ]
  }
]
